import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatTableComponent } from '../components/mat-table/mat-table.component';
import { RowActionsComponent } from '../components/row-actions/row-actions.component';
// Breadcrumbs
import { GlobalBreadcrumbsComponent } from '../auth/global-breadcrumbs/global-breadcrumbs.component'
// // Input Components
import { GlobalInputComponent } from '../components/global-input/global.input.component';
import { GlobalSelectComponent } from '../components/global-select/global.select.component';
import { GlobalDateComponent } from '../components/global-date/global-date.component';
import { GlobalTextareaComponent } from '../components/global-textarea/global-textarea.component';
import { CreditCardComponent } from '../components/global-payment/credit-card/credit-card.component';
import { UpiComponent } from '../components/global-payment/upi/upi.component';

import { MaterialModule } from '../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';

// Directives
import {InlineValidationDirective, DecimalDirective, CardFormateDirective, CvvFormatDirective, DateOfBirthDirective, CheckDomainDirective, LoaderDirective, DragDropDirective, DisableCopyPasteDirective, LowercaseInputDirective } from '../directives';

// loader
import { LoaderModule } from './loader/loader.module';

// Services
import { DataService } from '../services/data.service';
import { FlightItineraryComponent } from './flight-itinerary/flight-itinerary.component';
import { FlightRoundItineraryComponent } from './flight-itinerary/flight-round-itinerary/flight-round-itinerary.component';
import { FlightMultiItineraryComponent } from './flight-itinerary/flight-multi-itinerary/flight-multi-itinerary.component';
import { FilterAmenitiesComponent } from '../components/global-dialog/hotel/filter-amenities/filter-amenities.component';
import { HotelTypeComponent } from '../components/global-dialog/hotel/hotel-type/hotel-type.component';
import { BookingComponent } from './booking/booking.component';


import { NotFoundComponent } from '../components/not-found/not-found.component';
import { ImagesDialogComponent } from '../components/global-dialog/hotel/images-dialog/images-dialog.component';
import { CancellationPolicyComponent } from '../components/global-dialog/hotel/cancellation-policy/cancellation-policy.component';
import { ProcessComponent } from '../components/process/process.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PaymentDesignComponent } from './payment-design/payment-design.component';
import { GSTComponent } from './payment-design/gst/gst.component';
import { AcknowledgementComponent } from './booking/acknowledgement/acknowledgement.component';

import { HotelAcknowledgementComponent } from '../hotel/hotel-booking/hotel-acknowledgement/hotel-acknowledgement.component';
import { AuthHeaderComponent } from '../auth/auth-header/auth-header.component';
import { AuthFooterComponent } from '../auth/auth-footer/auth-footer.component';
import { MatHotelGuestComponent } from '../components/mat-hotel-guest/mat-hotel-guest.component';
import { RequiredComponent } from '../components/required/required.component';
import { TravellerDetailsComponent } from '../components/global-dialog/hotel/traveller-details/traveller-details.component';
import { TravellerFormComponent } from '../components/global-dialog/hotel/traveller-form/traveller-form.component';
import { GlobalInnerBannerComponent } from '../components/global-inner-banner/global-inner-banner.component';
import { SideNavComponent } from '../auth/side-nav/side-nav.component';
import { BookingTermConditionComponent } from './static/booking-term-condition/booking-term-condition.component';
import { PolicyComponent } from './static/policy/policy.component';
import { DisclaimerComponent } from './static/disclaimer/disclaimer.component';
import { GstPopupComponent } from './gst-popup/gst-popup.component';
import { ThankyouPopupComponent } from './thankyou-popup/thankyou-popup.component';
import { ChangePasswordComponent } from '../auth/change-password/change-password.component';
import { FileInputComponent } from '../components/file-input/file-input.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { DomesticFlightRoundItineraryComponent } from './flight-itinerary/domestic-flight-round-itinerary/domestic-flight-round-itinerary.component';
import { AuthDialogModule } from '../components/global-dialog/auth-dialog/auth-dialog.module';
import { AmenitiesDialogComponent } from '../hotel/amenities-dialog/amenities-dialog.component';
import { FilterPipe, FormatTimePipe, GlobalCurrencyPipe, TimeDifferencePipe, SortByDateTimePipe, EnsureArrayPipe, SortPassengersPipe, UniquePipe, ConvertToKeyValuePipe, SSRListActivePipe, ImageUrlPipe, TruncatePipe, RemoveHttpPipe,
  ExtractTextPipe, ExtractOriginDestinationPipe, ExtractValidatingCarrierPipe, AltCheckPipe, TransformUnitPipe, SortByTenurePipe, WraParenthesesPipe, SeatLimitPipe,
  SplitCamelCasePipe, FixPerPipe, CategoryLabelPipe, HasOptionsPipe, BankingOdderPipe, PaymentOfferLabelPipe, SeatFilterTicketsPipe, BaggageFormatPipe, HighlightKeyPipe, CancelFormatPipe,
  AncillariesByRoutePipe,
  UniqueCrsPnrPipe,
  EMIPaymentOfferPipe,
  JourneydurationPipe,
  AddLayoverDurationPipe,
  CountryNamePipe,
  CorporateFilterPipe,
  CarrierExtractPipe,
  FlightMinMaxFilterPipe,
  BookingFilterFlightPipe,
  CorporateBalancePipe,
  HubSpokeEligiblePipe} from '../pipe';
import { FlightInnerHeaderComponent } from '../flight/flight-result/flight-inner-header/flight-inner-header.component';
import { CommonLoaderComponent } from '../components/common-loader/common-loader.component';
import { InvalidCredentialsComponent } from '../components/invalid-credentials/invalid-credentials.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BelairTestPaymentComponent } from '../components/global-payment/belair-test-payment/belair-test-payment.component';
import { DebitCardComponent } from '../components/global-payment/debit-card/debit-card.component';
import { WalletPaymentComponent } from '../components/global-payment/wallet-payment/wallet-payment.component';
import { NetBankingComponent } from '../components/global-payment/net-banking/net-banking.component';
import { FlightsTicketsComponent } from '../air-cart/tickets-views/flights-tickets/flights-tickets.component';
import { LoginComponent } from '../auth/login/login.component';
import { CorporateRegisterComponent } from '../auth/corporate-register/corporate-register.component';
import { ForgotPasswordComponent } from '../auth/forgot-password/forgot-password.component';
import { CorporateFooterComponent } from '../auth/corporate-footer/corporate-footer.component';
import { FlightReportComponent } from './report/flight-report/flight-report.component';
import { FestiveBannerComponent } from '../components/festive-banner/festive-banner.component';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';
import { FlightManagementComponent } from './management/flight-management/flight-management.component';

@NgModule({
  declarations: [
    InlineValidationDirective,
    DecimalDirective,
    MatTableComponent,
    RowActionsComponent,
    UpiComponent,
    CreditCardComponent,
    FlightItineraryComponent,
    FlightRoundItineraryComponent,
    FlightMultiItineraryComponent,
    FilterAmenitiesComponent,
    HotelTypeComponent,
    BookingComponent,
    ImagesDialogComponent,
    CancellationPolicyComponent,
    PaymentDesignComponent,
    GSTComponent,
    AcknowledgementComponent,
    AmenitiesDialogComponent,
    HotelAcknowledgementComponent,
    AuthFooterComponent,
    AuthHeaderComponent,
    NotFoundComponent,
    ProcessComponent,
    MatHotelGuestComponent,
    GlobalInputComponent,
    GlobalSelectComponent,
    GlobalDateComponent,
    GlobalTextareaComponent,
    RequiredComponent,
    TravellerDetailsComponent,
    TravellerFormComponent,
    GlobalInnerBannerComponent,
    SideNavComponent,
    GstPopupComponent,
    ThankyouPopupComponent,
    GlobalBreadcrumbsComponent,
    ChangePasswordComponent,
    FileInputComponent,
    ErrorPopupComponent,
    DomesticFlightRoundItineraryComponent,
    CardFormateDirective,
    CvvFormatDirective,
    FilterPipe,
    DateOfBirthDirective,
    FlightInnerHeaderComponent,
    GlobalCurrencyPipe,
    FormatTimePipe,
    TimeDifferencePipe, SortByDateTimePipe, EnsureArrayPipe, SortPassengersPipe, UniquePipe, ConvertToKeyValuePipe, SSRListActivePipe,
    CheckDomainDirective,
    LoaderDirective,
    CommonLoaderComponent,
    InvalidCredentialsComponent,
    ImageUrlPipe,
    TruncatePipe,
    DragDropDirective,
    RemoveHttpPipe,
    ExtractTextPipe,
    ExtractOriginDestinationPipe,
    ExtractValidatingCarrierPipe,
    DisableCopyPasteDirective,
    AltCheckPipe,
    TransformUnitPipe,
    SortByTenurePipe,
    WraParenthesesPipe,
    SeatLimitPipe,
    SplitCamelCasePipe,
    FixPerPipe,
    CategoryLabelPipe,
    HasOptionsPipe,
    BelairTestPaymentComponent,
    DebitCardComponent,
    WalletPaymentComponent,
    NetBankingComponent,
    BankingOdderPipe,
    PaymentOfferLabelPipe,
    SeatFilterTicketsPipe,
    BaggageFormatPipe,
    HighlightKeyPipe,
    CancelFormatPipe,
    AncillariesByRoutePipe,
    UniqueCrsPnrPipe,
    FlightsTicketsComponent,
    EMIPaymentOfferPipe,
    LowercaseInputDirective,
    JourneydurationPipe,
    AddLayoverDurationPipe,
    CountryNamePipe,
    LoginComponent,
    CorporateRegisterComponent,
    ForgotPasswordComponent,
    CorporateFilterPipe,
    CorporateFooterComponent,
    CarrierExtractPipe,
    FlightMinMaxFilterPipe,
    BookingFilterFlightPipe,
    CorporateBalancePipe,
    HubSpokeEligiblePipe,
    FlightReportComponent,
    FestiveBannerComponent,
    FileUploadComponent,
    FlightManagementComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    LoaderModule,
    CarouselModule,
    ScrollingModule
  ],
  providers: [DataService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  exports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    InlineValidationDirective,
    DecimalDirective,
    MatTableComponent,
    RowActionsComponent,
    FlightItineraryComponent,
    FlightRoundItineraryComponent,
    FlightMultiItineraryComponent,
    FilterAmenitiesComponent,
    HotelTypeComponent,
    BookingComponent,
    ImagesDialogComponent,
    CancellationPolicyComponent,
    PaymentDesignComponent,
    AcknowledgementComponent,
    AmenitiesDialogComponent,
    HotelAcknowledgementComponent,
    AuthFooterComponent,
    AuthHeaderComponent,
    NotFoundComponent,
    ProcessComponent,
    MatHotelGuestComponent,
    RequiredComponent,
    GlobalInputComponent,
    GlobalSelectComponent,
    GlobalDateComponent,
    GlobalTextareaComponent,
    TravellerDetailsComponent,
    TravellerFormComponent,
    GlobalInnerBannerComponent,
    SideNavComponent,
    GlobalBreadcrumbsComponent,
    ChangePasswordComponent,
    FileInputComponent,
    ErrorPopupComponent,
    DomesticFlightRoundItineraryComponent,
    CardFormateDirective,
    CvvFormatDirective,
    DateOfBirthDirective,
    FlightInnerHeaderComponent,
    GlobalCurrencyPipe,
    FormatTimePipe,
    TimeDifferencePipe, SortByDateTimePipe, EnsureArrayPipe, SortPassengersPipe, UniquePipe, ConvertToKeyValuePipe, SSRListActivePipe,
    CheckDomainDirective,
    LoaderDirective,
    CommonLoaderComponent,
    InvalidCredentialsComponent,
    ScrollingModule,
    ImageUrlPipe,
    TruncatePipe,
    DragDropDirective,
    RemoveHttpPipe,
    ExtractTextPipe,
    ExtractOriginDestinationPipe,
    ExtractValidatingCarrierPipe,
    DisableCopyPasteDirective,
    AltCheckPipe,
    TransformUnitPipe,
    SortByTenurePipe,
    WraParenthesesPipe,
    SeatLimitPipe,
    SplitCamelCasePipe,
    FixPerPipe,
    CategoryLabelPipe,
    HasOptionsPipe,
    UpiComponent,
    CreditCardComponent,
    BelairTestPaymentComponent,
    DebitCardComponent,
    WalletPaymentComponent,
    NetBankingComponent,
    BankingOdderPipe,
    PaymentOfferLabelPipe,
    SeatFilterTicketsPipe,
    BaggageFormatPipe,
    HighlightKeyPipe,
    CancelFormatPipe,
    AncillariesByRoutePipe,
    UniqueCrsPnrPipe,
    FlightsTicketsComponent,
    EMIPaymentOfferPipe,
    LowercaseInputDirective,
    JourneydurationPipe,
    AddLayoverDurationPipe,
    CountryNamePipe,
    LoginComponent,
    CorporateRegisterComponent,
    ForgotPasswordComponent,
    CorporateFilterPipe,
    CorporateFooterComponent,
    CarrierExtractPipe,
    FlightMinMaxFilterPipe,
    BookingFilterFlightPipe,
    CorporateBalancePipe,
    HubSpokeEligiblePipe,
    FestiveBannerComponent,
    FileUploadComponent
  ]
})
export class SharedModule { }
